import { Breadcrumbs } from 'components/bredcrambs';
import { IProvider } from 'constants/types';

import { CheckRtpBlock } from 'components/template/check-rtp-block';
import { Analytics } from 'constants/analytics';
import { Routes } from 'constants/routes';
import styles from './styles.module.css';

const items = [
  {
    id: 0,
    path: Routes.home,
    title: 'Home',
  },
  {
    id: 1,
    path: Routes.allSlots,
    title: 'Slots',
  },
  {
    id: 2,
    path: Routes.providers,
    title: 'Providers',
  },
];

export const HeaderProviderById = ({ data }: { data: IProvider }) => {
  return (
    <div className={styles.container}>
      <Breadcrumbs
        items={[
          ...items,
          {
            id: 3,
            path: '#',
            title: data?.name ?? '',
          },
        ]}
      />

      <h1 className={styles.title}>
        {data?.name} {'Slots'}
      </h1>

      <CheckRtpBlock
        id={Analytics.provider.guide}
        provider={data}
        disableMargins
      />
    </div>
  );
};
